<template>
	<div id="markers" style="padding-top:3vw;">
		<div class="page" style="padding-bottom:15vw;">
		<router-link to="/markerinfo">
		  <div class="logdetail" style="margin-top:0px;">
				<div class="subject">累计奖励（元）</div>
				<div class="price">
					{{marker.allprice}}
					<div class="btn" bindtap="event_info">奖励规则 ></div>
				</div>
		  </div>
		</router-link>
		  <div class="setbox" v-for="item in marker.set">
			<div class="title">{{item.subject}}：<span style="color:coral;font-weight:bold;margin-right:2vw;font-size:5.2vw;">{{item.price}}</span>元</div>
			<div class="detailbox">
			  <div class="left">
				达标数量
				<div class="num">
				  {{item.number}}
				</div>
			  </div>
			  <div class="right">
				已完成数量
				<div class="num">
				  {{item.overnum}}
				</div>
			  </div>
			</div>
		  </div>
		  <div class="detailbtn" v-on:click="event_reward">查看明细</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Markers',
	data () {
		return {
			marker:{}
		}
	},
	created (){
		var that = this;
		this.$https.post('/api/marker/index',this.$qs.stringify({
			token:this.$store.state.token
		})).then((res) => {
			this.marker = res.data.data.marker
		}).catch((res) => {
			console.log('请求失败');
		})
	},
	methods : {
		event_reward(){
			this.$router.push({ 
				path:'/rewardlist',
				query:{
					id:this.marker.id
				}
			})
		}
	}
}
</script>
<style scoped>
	#markers{
		background-color:#FFFFFF;
		min-height:100vh;
	}
</style>


// WEBPACK FOOTER //
// src/components/Marker.vue